import React from 'react';

export default function SLAReminder() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">SLA & Reminder</h1>
      <p className="text-gray-500">Halaman SLA & Reminder</p>
    </div>
  );
}
